"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastCreatedAt = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const logger_1 = require("../logger");
function lastCreatedAt() {
    return (0, rxjs_1.pipe)((0, operators_1.map)((group) => {
        if (!Array.isArray(group)) {
            logger_1.logger.error(`lastCreatedAt must be piped an array`);
            return group;
        }
        if (group.length === 0) {
            return undefined;
        }
        return group.reduce((prev, current) => {
            if (!prev.clientCreatedAt || !current.clientCreatedAt) {
                logger_1.logger.error('No clientCreatedAt property was found on wall item ID ' + current.id);
                return current;
            }
            return prev.clientCreatedAt.seconds > current.clientCreatedAt.seconds
                ? prev
                : current;
        });
    }));
}
exports.lastCreatedAt = lastCreatedAt;
//# sourceMappingURL=last_created_at.js.map